import {
  useFilterUnit,
  useSetFilter,
} from "@/hooks/useFilter";
import { Units as UnitsEnum } from "@/data/schema";
import { useCache } from "@/hooks/useCache";
import { useCallback, CSSProperties } from "react";

interface UnitsProps {
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Units({ disabled = false, className = "", style }: UnitsProps) {
  const defaultClassName = "px-2 py-1 text-secondary bg-main border border-secondary/50 rounded outline-none focus:border-secondary transition-colors cursor-pointer text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed shrink-0";
  const finalClassName = className ? `${defaultClassName} ${className}` : defaultClassName;
  const { data } = useCache();
  const [unit] = useFilterUnit();
  const { setFilter } = useSetFilter();

  // Converter (Remember to this at some point)
  const convertUnits = useCallback(
    (nextUnit: UnitsEnum) => {
      if (!data || disabled) return;

      setFilter((prev) => {
        const nextSpices = new Map(prev.spices);

        nextSpices.forEach((spice, id) => {
          const portion = data[Number(id)]?.portions?.[nextUnit];
          if (!portion || portion <= 0) return;

          const wholeUnits = Math.floor(spice.quantity / portion);
          const snappedQuantity = wholeUnits * portion;

          nextSpices.set(id, {
            ...spice,
            quantity: Number(snappedQuantity.toFixed(3)),
          });
        });

        return { ...prev, unit: nextUnit, spices: nextSpices };
      });
    },
    [data, setFilter, disabled]
  );

  return (
    <select
      value={unit}
      onChange={(e) => convertUnits(e.target.value as UnitsEnum)}
      disabled={disabled}
      className={finalClassName}
      style={style}
    >
      <option value={UnitsEnum.GRAM}>{UnitsEnum.GRAM}</option>
      <option value={UnitsEnum.TBSP}>{UnitsEnum.TBSP}</option>
      <option value={UnitsEnum.TSP}>{UnitsEnum.TSP}</option>
    </select>
  );
}
